import { IconX } from '@tabler/icons-react';
import { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import { postApi } from '../../../../api/call.api';
import { urlApi } from '../../../../api/url.api';
import { loadingHide, loadingShow } from '../../../../loadingUi/loading.controller';
import { uploadFile } from '../../../../api/api.global';

const availableKeys = [
    "user.visitorName",
    "user.chatSessionCount",
    "user.lastMessage",
    "user.status",
    "user.visitorOnlineStatus"
];

const EditCannedReplyModal = ({ buttonComponent, callback, rowData }) => {

    const [show, setShow] = useState(false);
    const [selectedTags, setSelectedTags] = useState(rowData?.tags || []);

    const [selectedMediaType, setSelectedMediaType] = useState(rowData?.messageType || null);
    const [file, setFile] = useState(null);

    const [inputValue, setInputValue] = useState(rowData?.message);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [cursorPos, setCursorPos] = useState(0);
    const inputRef = useRef(null);

    const handleClose = () => { setSelectedTags([]); setInputValue(""); setShowSuggestions(false); setSelectedMediaType(null); setFile(null); setShow(false) };
    const handleShow = () => { setShow(true); setInputValue(rowData?.message); setSelectedMediaType(rowData?.messageType || null) };

    const update = async () => {

        let localData = {
            message: document.getElementById("message")?.value?.trim(),
            tags: selectedTags
        }
        let postData = {
            cannedReplyId: rowData?._id,
            message: localData.message,
            tags: localData.tags,
            messageType: (selectedMediaType) || 1
        }

        if (selectedMediaType == 2) {
            postData.file = file ? await uploadFile(file, 'advy-canned-reply-file') : rowData?.file;
        }

        if (selectedMediaType == 3) {
            postData.voice = file ? await uploadFile(file, 'advy-canned-reply-voice-file') : rowData?.voice;
        }

        loadingShow();
        let resp = await postApi(postData, urlApi?.updateCannedReply);
        loadingHide();
        if (resp.responseCode == 200) {
            toast.success(resp?.message);
            callback?.();
            handleClose();
        } else {
            toast.error(resp?.message);
        }
    }

    const handleChange = (e) => {
        const value = e.target.value;
        const cursor = e.target.selectionStart;
        setInputValue(value);
        setCursorPos(cursor);

        const textBeforeCursor = value.slice(0, cursor);
        const justTyped = textBeforeCursor.slice(-2);

        if (justTyped === "{{") {
            setShowSuggestions(true);
        } else {
            setShowSuggestions(false);
        }
    };

    const handleSelect = (key) => {
        const before = inputValue.slice(0, cursorPos);
        const after = inputValue.slice(cursorPos);
        const newValue = `${before}${key}}}${after}`; // Already typed '{{'
        setInputValue(newValue);
        setShowSuggestions(false);

        // Restore cursor
        setTimeout(() => {
            const newCursor = before.length + key.length + 2;
            inputRef.current.setSelectionRange(newCursor, newCursor);
            inputRef.current.focus();
        }, 0);
    };

    useEffect(() => {
        if (show) {
            setSelectedTags(rowData?.tags)
        }
    }, [rowData, show]);

    const tags = ['Acknowledgement', 'Apologies', 'Feedback', 'Forward', 'Greetings', 'Internal Transfer', 'Issue Fixed', 'Issue Reported', 'Reminder', 'Request', 'Response', 'Thank You', 'New Visitor', 'Pricing enquiry', 'Repeated Visitor'];

    const handleTagClick = (tag) => {
        if (selectedTags.includes(tag)) {
            setSelectedTags(selectedTags.filter(item => item !== tag));
        } else {
            setSelectedTags([...selectedTags, tag]);
        }
    }

    return (
        <>
            <div className='max-w-max' onClick={handleShow}>{buttonComponent}</div>
            <Modal show={show} onHide={handleClose} backdrop="static" size='lg'>
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold mb-0">Edit Canned Reply Message</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <div className='relative'>
                        <div className='mb-3'>
                            <label htmlFor="name" className='text-sm font-semibold mb-1'>Message</label>
                            <textarea type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" defaultValue={rowData?.message} id='message' rows={5} ref={inputRef} value={inputValue}
                                onChange={handleChange}></textarea>
                        </div>
                        {showSuggestions && (
                            <ul className="absolute bg-white border rounded shadow p-2 mt-1 z-10 w-full max-h-48 overflow-y-auto">
                                {availableKeys.map((key) => (
                                    <li
                                        key={key}
                                        className="cursor-pointer hover:bg-gray-200 px-2 py-1"
                                        onClick={() => handleSelect(key)}
                                    >
                                        {key}
                                    </li>
                                ))}
                            </ul>
                        )}
                        <div className="mb-3">
                            <label htmlFor="">Tags</label>
                            <div className='flex flex-wrap gap-2 mt-1'>
                                {
                                    tags?.map((item, index) => {
                                        return (
                                            <button key={index} onClick={() => handleTagClick(item)} className={`${selectedTags.includes(item) ? 'bg-primary text-white' : 'bg-gray-100'} text-gray-600 rounded-md px-2 py-1 text-xs`}>{item}</button>
                                        )
                                    })
                                }
                            </div>
                        </div>

                        <div className="mb-6">
                            <label htmlFor="media-list-type" className="block text-sm font-medium text-gray-700 mb-1">
                                Add Media
                            </label>
                            <select
                                id="media-list-type"
                                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                                defaultValue={rowData?.messageType || null}
                                onChange={(e) => setSelectedMediaType(e.target.value)}
                            >
                                <option value={null}>None</option>
                                <option value={2}>Image/File</option>
                                <option value={3}>Audio</option>
                            </select>

                            {selectedMediaType && (
                                <div className="mt-4">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Upload File
                                    </label>
                                    <input
                                        type="file"
                                        accept={
                                            selectedMediaType == 2
                                                ? "*"
                                                : selectedMediaType == 3
                                                    ? "audio/*"
                                                    : "*"
                                        }
                                        onChange={(e) => setFile(e.target.files[0])}
                                        className="block w-full text-sm text-gray-700 border border-gray-300 rounded-md cursor-pointer focus:outline-none"
                                    />
                                </div>
                            )}

                            {(selectedMediaType == 2) && (
                                <div className="mt-4">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Preview</label>
                                    <img
                                        src={file ? URL.createObjectURL(file) : rowData?.file}
                                        alt="Sorry Preview not available for this file type."
                                        className="w-32 h-32 object-cover rounded-md border"
                                    />
                                </div>
                            )}

                            {(selectedMediaType == 3) && (
                                <div className="mt-4">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Preview</label>
                                    <audio controls src={file ? URL.createObjectURL(file) : rowData?.voice} className="w-full rounded-md" />
                                </div>
                            )}

                            {(selectedMediaType == 2) && (
                                <div className="mt-4">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">File Name</label>
                                    <p className="text-sm text-gray-800">{file ? file?.name : rowData?.file}</p>
                                </div>
                            )}
                        </div>
                    </div>

                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => update()}>Update</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default EditCannedReplyModal